import { Pipe, PipeTransform } from '@angular/core';

import { Observable, delay, of } from 'rxjs';

@Pipe({
  name: 'finDelay',
  standalone: false,
})
export class DelayPipe implements PipeTransform {
  transform(): undefined;
  transform<T>(input: T | undefined, delayInMilliSeconds?: number): undefined;
  transform<T>(input: Observable<T>, delayInMilliSeconds?: number): Observable<T>;
  transform<T>(input: T, delayInMilliSeconds?: number): Observable<T>;
  transform<T>(input?: Observable<T> | T, delayInMilliSeconds = 1): Observable<T> | undefined {
    if (input === undefined) {
      return undefined;
    }
    if (input && input instanceof Observable) {
      return input.pipe(delay(delayInMilliSeconds));
    }
    return of(input as T).pipe(delay(delayInMilliSeconds));
  }
}
